import { useMemo, type ImgHTMLAttributes, type PropsWithChildren } from 'react';
import { parseImageConfig } from './image.config.parser';

type ImageProps = PropsWithChildren<ImgHTMLAttributes<HTMLImageElement>> & {
  config?: Parameters<typeof parseImageConfig>['0'];
  fallbackSrc?: string;
}

export const Image = ( { children, config, src, fallbackSrc, ...imgProps }: ImageProps ) => {

  const imageSources = useMemo( () => {
    if ( config == null ) {
      return null;
    }

    return parseImageConfig( config );
  }, [ config ] );

  if ( imageSources != null ) {
    return (
      <picture>
        { imageSources.map( ( source, index ) => {
          const srcSet = new URL( source.srcSet ? source.srcSet : src ?? '' );
          if( source.width ) {
            srcSet.searchParams.set( 'w', source.width.toString() );
          }

          if ( source.fit ) {
            srcSet.searchParams.set( 'fit', source.fit );
          }

          srcSet.searchParams.set( 'format', source.format )

          return (
            <source
              key={ index }
              srcSet={ srcSet.toString() }
              type={ source.type }
              media={ source.media }
            />
          )
        } )}
        <img
          src={ fallbackSrc ?? src }
          { ...imgProps }
        />
      </picture>
    )
  }

  return (
    <img
      src={ src }
      { ...imgProps }
    />
  )
}
Image.displayName = 'Image';
